<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row row-space">
            
            <div class="form-item-char30">
                <label class="label-caption">Tipo</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <RegiaoSelect :ckAddTodos="true" :disabled="!opcaoSelecionadaObj.ckregiao" v-model:idSelecionado="idRegiao" />
            <LocalidadeSelect :ckAddTodos="true" :disabled="!opcaoSelecionadaObj.cklocal" v-model:idSelecionado="idLocalidade" />
        </div>

        <div class="row-end">
            <button type="button" class="buttom-icon--printer" @click="openReport" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import LocalidadeSelect from '@/selects/LocalidadeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import RegiaoSelect from '@/selects/RegiaoSelect.vue';

const emit = defineEmits(['close']);
const msgAlerta = ref(null);
const idLocalidade = ref(null);
const idRegiao = ref(null);
const isLoading = ref(false);

const lsOpcoes = ref([
    {id: 'propriedades',  descricao: 'Propriedades',         cklocal: true, ckregiao: true},
]);
const opcaoSelecionada = ref('propriedades');
const opcaoSelecionadaObj = computed(() =>
    lsOpcoes.value.find(o => o.id === opcaoSelecionada.value) || {}
);

const closeForm = () => {emit('close');}

const openReport = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;

        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idmunicipio: globalStore.idmunicipio,
            idlocalidade: idLocalidade.value,
            idregiao: idRegiao.value,
            idusuario: globalStore.idusuario};
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}
</script>